{
  "email": "郵箱",
  "emailAddress": "郵箱地址",
  "emailAddressPlaceholder": "請輸入您的郵箱地址",
  "continue": "繼續",
  "send": "發送",
  "resend": "重新發送",
  "sendCodeErrorTip": "發送驗證碼失敗：{error}",
  "sendEmailTips": "我們已向您的郵箱發送驗證碼",
  "verificationCode": "驗證碼",
  "codePlaceholder": "請輸入驗證碼",
  "wallet": "錢包",
  "otherLoginMethods": "其他登入方式",
  "login": "登入",
  "user": "用戶",
  "loginTitle": "登入 / 註冊",
  "loginTips": "您可以使用以下方式登入",
  "passwordMinError": "密碼必須至少包含 {length} 個字符",
  "passwordMatchError": "兩次輸入的密碼不一致",
  "passwordTitle": "設置密碼",
  "passwordTips": "請設置用於恢復錢包的密碼",
  "password": "密碼",
  "passwordPlaceholder": "請輸入您的密碼",
  "rePassword": "確認密碼",
  "rePasswordPlaceholder": "請再次輸入密碼",
  "recoverTitle": "恢復錢包",
  "recoverTips": "請輸入您的密碼以恢復錢包",
  "bindWith": "綁定 {name} 錢包",
  "loginWith": "使用 {name} 錢包登入",
  "editUsernameTitle": "修改用戶名",
  "setUsernameTitle": "設置用戶名",
  "username": "用戶名",
  "usernamePlaceholder": "請輸入您的用戶名",
  "usernameValidError": "用戶名可以由數字、字母和字符組成",
  "usernameLengthError": "用戶名不得少於 2 個字符",
  "confirm": "確認",
  "nextTime": "下次再說",
  "setUsername": "設置用戶名",
  "disconnect": "斷開連接",
  "CEXBindTitle": "綁定 {type} API",
  "CEXBindAttention": "注意：",
  "CEXBindTips1": "1. 請綁定具有只讀權限的 API。",
  "CEXBindTips2": "2. 您的 API 可能已過期，建議使用長期有效的 API。",
  "CEXBindTips3": "3. 同一時間只能綁定一個 API 到相同的交易所。",
  "CEXBindApiKey": "API 金鑰",
  "CEXBindApiSecretKey": "API 密鑰",
  "CEXBindApiPassphrase": "API 密碼短語",
  "cancel": "取消",
  "walletLoading": "錢包服務正在加載",
  "tokenDetails": "代幣詳情",
  "tokenAmountMin": "金額必須大於 0。",
  "tokenAmountMax": "餘額不足。",
  "tokenAddressError": "無效的地址。",
  "amount": "金額",
  "amountPlaceholder": "請輸入金額。",
  "balance": "餘額",
  "receiveTitle": "接收錢包地址",
  "receivePlaceholder": "請輸入接收錢包地址。",
  "next": "下一步",
  "copied": "已複製",
  "receiveQrcode": "掃描 QR 碼接收",
  "copyAddress": "複製地址",
  "tokenSmartContract": "代幣智能合約",
  "tokenSmartContractPlaceholder": "請輸入代幣智能合約。",
  "tokenSymbol": "代幣符號",
  "tokenSymbolPlaceholder": "請輸入代幣符號。",
  "tokenDecimals": "小數位數",
  "tokenDecimalsPlaceholder": "請輸入小數位數。",
  "import": "導入",
  "receive": "接收",
  "customizedToken": "自定義代幣",
  "noMoreRecords": "沒有更多交易記錄了！",
  "noRecords": "暫無交易記錄！",
  "close": "關閉",
  "back": "返回",
  "importSuccess": "成功匯入代幣",
  "importFail": "匯入代幣失敗",
  "changeNetwork": "切換網絡",
  "approveSuccess": "授權成功",
  "Approve": "授權",
  "noFriends": "暫無好友",
  "noRequests": "暫無請求",
  "noMore": "沒有更多",
  "Remove": "移除",
  "removeSuccess": "移除成功"

}